import axios from 'axios'
import i18next from 'i18next'
import Cookies from 'js-cookie'
import { enqueueSnackbar, closeSnackbar } from "notistack"
import toastMessage from '@/utils/toastMessage'
import { getTaskId, getToken, onLogout, setToken, getTmpToken, setTmpToken, onUserLogout } from '../redux/slices/user'
import { dispatch } from '../redux/store'
import * as requestEncryptUtil from '@/utils/requestCrypto'
// const baseURL = import.meta.env.BASE_URL;
const baseURL = '/'
const NOT_SHOW_TOAST_CODES = [7032]
const axiosInstance = axios.create({
  baseURL,
  timeout: 30000,
})

// Exception handle
function errorHandler (error) {
  const { status } = error
  if (status) {
    if (status === 401) {
      // if (![
      //   '/wapi/v1/activity/channel/bind'
      // ].includes(error.config.url)) {
      //   enqueueSnackbar('Request Failed', { variant: 'error' })
      // }

      dispatch(onUserLogout());
      return Promise.reject(error)
    }
    enqueueSnackbar('Request Failed', { variant: 'error' })
  }
  return Promise.reject(error)
}

// 请求阶段加密
axiosInstance.interceptors.request.use(requestEncryptUtil.axioxRequestInterceptor)

axiosInstance.interceptors.request.use((config) => {
  // append token if need
  const accessToken = getToken()
  const tmpToken = getTmpToken()
  if (accessToken || tmpToken) {
    config.headers['X-OToken'] = accessToken ?? tmpToken
    config.headers['X-Token'] = accessToken ?? tmpToken//用户接口请求加密
  }

  config.headers['X-Ts'] = new Date().getTime();

  // lang
  let currentLang = i18next.language || 'en'
  if (currentLang === 'hk') {
    currentLang = 'zh_HK'
  }
  else if (currentLang === 'cn') {
    currentLang = 'zh_CN'
  }

  config.headers.Lang = currentLang

  // 标准版 mid
  // config.headers['X-Mid'] = "aa44a0b7485f41ba940ce315754e6e57";
  config.headers['X-Platform'] = 'web';

  // 2FA taskId
  const taskId = getTaskId();
  if (taskId) {
    config.headers['X-Auth-TaskId'] = taskId;
  }

  config.headers['X-Webapp-Version'] = window.appVersion;

  if (config.data) {
    config.headers['Content-Type'] = 'application/json'
  }

  return config
}, errorHandler)

axiosInstance.interceptors.response.use(requestEncryptUtil.axioxResponseInterceptor, errorHandler)

axiosInstance.interceptors.response.use((response) => {
  const responseData = response.body || response.data
  // biz service code
  const code = responseData?.code
  if (code) {
    if (code === 200) {
      // origin response. do not return response data/body.
      if (response.config.originResponse)
        return responseData
      return responseData.body || responseData.data
    }
    const token = getToken()

    if (code === 601 && !token) {
      // 如果已是登出态 601不应再弹错误
      dispatch(onUserLogout())
    } else if (code === 601 || code == 401 || code == 682) {
      // 已经执行过登出 token为null则不需要重复登出
      if (getToken()) {
        dispatch(onUserLogout())
      }
    }
    
    if (code === 632 || code === 7031) {
      toastMessage(responseData.msg, 'error')
      // enqueueSnackbar(responseData.msg || 'Interval Error', { variant: 'error' })
      return Promise.reject(new Error(responseData.msg || `error_${code}`))
    }

    if (code === 644) {
      return Promise.reject(responseData);
    }

    if (!NOT_SHOW_TOAST_CODES.includes(code)) {
      // closeSnackbar()
      toastMessage(responseData.msg, 'error')
      // enqueueSnackbar(responseData.msg || `error_${code}`, { variant: 'error' })
    }

    return Promise.reject(new Error(responseData.msg || `error_${code}`))
  }
  return responseData
}, errorHandler)

export default axiosInstance
